export const UPDATE_STATS = 'UPDATE_STATS';

interface SellerStatsState {
    /** e.g. `2+ years` */
    postingSince: string;
    replySpeed: null | number;
    replyRate: null | number;
}

export const updateStats = (payload) => ({
    type: UPDATE_STATS,
    payload,
});

export default function sellerStatsReducer(state = {} as SellerStatsState, action): SellerStatsState {
    return action.type === UPDATE_STATS ? action.payload : state;
}
